import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { notify } from '../services/notification';

/**
 * When is_first_login === true:
 *   - Only /setting/changepassword is accessible
 *   - Every other private route redirects to /setting/changepassword
 *
 * When is_first_login === false/undefined:
 *   - Renders children normally (existing PrivateRoute handles auth)
 */
export const FirstLoginRoute = ({ children }) => {
  const location = useLocation();

  // Read from Redux (runtime) with cookie fallback (for page refresh)
  const isFirstLoginRedux = useSelector((state) => state.firstLogin?.isFirstLogin);
  const isFirstLoginCookie = Cookies.get('is_first_login') === 'true';
  const isFirstLogin = isFirstLoginRedux || isFirstLoginCookie;

  const CHANGE_PASSWORD_PATH = '/setting/changepassword';

  useEffect(() => {
    if (isFirstLogin && location.pathname !== CHANGE_PASSWORD_PATH) {
      notify.warning('Please reset your password first.');
    }
  }, [isFirstLogin, location.pathname, CHANGE_PASSWORD_PATH]);

  if (isFirstLogin && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  }

  return children;
};
